import { render, staticRenderFns } from "./IosInstallInstructions.vue?vue&type=template&id=6f33b97a&scoped=true&"
import script from "./IosInstallInstructions.vue?vue&type=script&lang=js&"
export * from "./IosInstallInstructions.vue?vue&type=script&lang=js&"
import style0 from "./IosInstallInstructions.vue?vue&type=style&index=0&id=6f33b97a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f33b97a",
  null
  
)

export default component.exports